import { ErrorMessages } from '@constants/errors'
import { useMessage } from '@hooks/useMessage'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { TableDataResponse } from '@interfaces/table.interface'
import { ICrm, ICrmLight } from '@interfaces/crm.interface'
import { errorMapper } from '@utils/errorMapper'
import { useEffect, useState } from 'react'
import { ITableState } from '@utils/sort'

interface IReturn {
  crms: ICrm[]
  count: number
  crmsLight: ICrmLight[]
  isLoading: boolean
}

export const useGetCrmList = (pagination?: ITableState): IReturn => {
  const { error } = useMessage()
  const [result, setResult] = useState<TableDataResponse<ICrm> & { crmsLight: ICrmLight[] }>()
  const [isLoading, setIsLoading] = useState(false)

  const getData = async () => {
    try {
      setIsLoading(true)
      const { data }: AxiosResponse<TableDataResponse<ICrm>> = await axiosInstance.get(
        serverPath.CRM,
        {
          params: {
            pageSize: pagination?.pagination ? pagination.pagination.pageSize : null,
            page: pagination?.pagination ? pagination.pagination.current : null,
            sort: pagination?.sort ? pagination.sort.sort : null,
            field: pagination?.sort ? pagination.sort.field : null,
            search: pagination?.search ? pagination?.search : null,
          },
        },
      )
      setResult({ ...data, crmsLight: data.rows.map((crm) => ({ id: crm.id, name: crm.name })) })
    } catch (e) {
      console.log(e)
      error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getData().then()
  }, [pagination])

  return {
    crms: result?.rows ?? [],
    count: result?.count ?? 0,
    crmsLight: result?.crmsLight ?? [],
    isLoading,
  }
}
